import { __assign } from "tslib";
import { COMPONENT_NAME_PREFIX } from '../constants';
var elementName = COMPONENT_NAME_PREFIX + "calendar";
var observedAttributes = {
    MONTH: 'month',
    YEAR: 'year',
    SHOW_TODAY: 'show-today',
    MULTISELECT: 'multiselect',
    MIN_DATE: 'min-date',
    MAX_DATE: 'max-date',
    MIN_YEAR: 'min-year',
    MAX_YEAR: 'max-year',
    PREVENT_FOCUS: 'prevent-focus',
    AUTO_SWITCH: 'auto-switch',
    RANGE: 'range',
    MODE: 'mode',
    SHOW_HEADER: 'show-header'
};
var attributes = __assign(__assign({}, observedAttributes), { DATA_YEAR: 'data-year', RANGE_PREVIEW: 'range-preview', RANGE_PREVIEW_START: 'range-preview-start', RANGE_PREVIEW_END: 'range-preview-end', RANGE_SELECTION: 'range-selection', RANGE_SELECTION_START: 'range-selection-start', RANGE_SELECTION_END: 'range-selection-end', DATA_DATE: 'data-date', DATA_EVENT_THEME: 'data-event-theme' });
var classes = {
    DATE: 'tyl-calendar__date',
    INTERACTIVE: 'tyl-calendar__date--interactive',
    TODAY: 'tyl-calendar__date--today',
    SELECTED: 'tyl-calendar__date--selected',
    DATE_ACTIVE: 'tyl-calendar__date--active',
    DISABLED: 'tyl-calendar__date--disabled',
    MONTH: 'tyl-calendar__month',
    YEAR: 'tyl-calendar__year',
    ACTIVE: 'active',
    HIGHLIGHTED: 'highlighted',
    DATE_WRAPPER: 'tyl-calendar__date__wrapper',
    EVENT: 'tyl-calendar__event',
    ADDITIONAL_EVENTS: 'tyl-calendar__event--additional',
    EVENT_WRAPPER: 'tyl-calendar__event__wrapper',
};
var ids = {
    ACTIVE_YEAR: 'active-year'
};
var selectors = {
    CALENDAR: '.tyl-calendar',
    MONTH_BUTTON: '#month-button',
    YEAR_BUTTON: '#year-button',
    PREVIOUS_BUTTON: '#previous-button',
    NEXT_BUTTON: '#next-button',
    CURRENT_MONTH: '#current-month',
    CURRENT_YEAR: '#current-year',
    VIEW_SWITCHER: '#view-switcher',
    DATE_VIEW: 'tcw-view #date-view',
    PICKER_DIVIDER: '#picker-divider',
    MONTH_VIEW: '#month-view',
    YEAR_VIEW: '#year-view',
    DATES: '#dates',
    YEARS: '#years',
    ACTIVE_YEAR: '#active-year',
    ACTIVE_DAY: "." + classes.DATE_ACTIVE,
    SELECTED_DATE: '.tyl-calendar__date--selected',
    HEADER: '#header'
};
var events = {
    DATE_SELECTED: COMPONENT_NAME_PREFIX + "date-select",
    DATE_RANGE_SELECTED: COMPONENT_NAME_PREFIX + "date-range-select",
    ACTIVE_CHANGE: COMPONENT_NAME_PREFIX + "active-change"
};
var numbers = {
    DEFAULT_YEAR_RANGE: 50
};
export var CALENDAR_CONSTANTS = {
    elementName: elementName,
    attributes: attributes,
    classes: classes,
    ids: ids,
    selectors: selectors,
    events: events,
    numbers: numbers
};
export var CalendarDateSelectType;
(function (CalendarDateSelectType) {
    CalendarDateSelectType[CalendarDateSelectType["date"] = 1] = "date";
    CalendarDateSelectType[CalendarDateSelectType["month"] = 2] = "month";
    CalendarDateSelectType[CalendarDateSelectType["year"] = 3] = "year";
})(CalendarDateSelectType || (CalendarDateSelectType = {}));
export var RangeSelectionState;
(function (RangeSelectionState) {
    RangeSelectionState[RangeSelectionState["none"] = 0] = "none";
    RangeSelectionState[RangeSelectionState["from"] = 1] = "from";
    RangeSelectionState[RangeSelectionState["to"] = 2] = "to";
})(RangeSelectionState || (RangeSelectionState = {}));
export var CalendarView;
(function (CalendarView) {
    CalendarView[CalendarView["Date"] = 0] = "Date";
    CalendarView[CalendarView["Month"] = 1] = "Month";
    CalendarView[CalendarView["Year"] = 2] = "Year";
})(CalendarView || (CalendarView = {}));
export var EventColor;
(function (EventColor) {
    EventColor["primary"] = "primary";
    EventColor["secondary"] = "secondary";
    EventColor["blue"] = "blue";
    EventColor["lightGreen"] = "light-green";
    EventColor["cyan"] = "cyan";
    EventColor["teal"] = "teal";
    EventColor["orange"] = "orange";
    EventColor["blueGrey"] = "blue-grey";
    EventColor["grey"] = "grey";
    EventColor["red"] = "red";
    EventColor["pink"] = "pink";
    EventColor["purple"] = "purple";
    EventColor["lightBlue"] = "light-blue";
    EventColor["deepPurple"] = "deep-purple";
    EventColor["green"] = "green";
    EventColor["lime"] = "lime";
    EventColor["yellow"] = "yellow";
    EventColor["brown"] = "brown";
    EventColor["deepOrange"] = "deep-orange";
})(EventColor || (EventColor = {}));
